import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

function WelcomeCard({ userName }) {
  const theme = useTheme();
  return (
    // borderRadius smaller than the sibling cards' 24px (WelcomeCard/UnattendedCard/
    // ContactsOverviewCard) is deliberate -- this card is much shorter than the
    // others, so the same 24px radius consumes proportionally more of its height
    // and reads as visibly "rounder" even though the value matches. 18px brings
    // the perceived roundness back in line (2026-08-18, Rahim's ask).
    <Box sx={{ backgroundColor: theme.palette.background.default, border: `1px solid ${theme.palette.divider}`, borderRadius: "18px", p: 2.5, flexShrink: 0 }}>
      <Typography sx={{ fontWeight: 700, fontSize: "1.25rem" }}>
        <Box component="span" sx={{ color: "#16E27C" }}>Welcome back,</Box> {userName} 👋
      </Typography>
      <Typography sx={{ color: "text.secondary", fontSize: "0.9375rem", mt: 0.5, whiteSpace: "nowrap" }}>
        Here's what's happening with your business today.
      </Typography>
    </Box>
  );
}

export default WelcomeCard;
